import {addHandler} from '../util/scroll_resize';
import {phoneMax} from './site';

let navigationOffset;
export let enableNavigationTrigger = false;

export function recalculateNavigationTrigger () {
  // can be called when inter content changes
  navigationOffset = document.querySelector('.site-header').offsetHeight;
}

export function trackNavigationTrigger () {
  addHandler({
    resize: function (winWidth, winHeight) {
      enableNavigationTrigger = winWidth < phoneMax;
      recalculateNavigationTrigger();
    },
    scroll: function (scrollY, scrollX) {
      if (navigationOffset < scrollY) {
        // scrolled past navigation
        if (!document.body.classList.contains('scrolled-past-navigation')) {
          document.body.classList.add('scrolled-past-navigation');
        }
      } else {
        // navigation visible
        if (document.body.classList.contains('scrolled-past-navigation')) {
          document.body.classList.remove('scrolled-past-navigation');
        }
      }
    }
  }, true);
}



// WEBPACK FOOTER //
// ./assets/j/src/navigation.js